import { Button } from "@/components/common";

interface SectionHeaderProps {
  title: React.ReactNode;
  description: string | React.ReactNode;
  buttonText: string;
  buttonTo: string;
}

const SectionHeader = ({ title, description, buttonText, buttonTo }: SectionHeaderProps) => {
  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between">
        <div className="flex flex-col items-center justify-between w-full gap-4 mb-6 sm:flex-row">
          <h2 className="text-[2rem] sm:text-[3rem] md:text-[4.2rem] font-bold leading-tight">
            {title}
          </h2>
          <Button
            size="lg"
            variant="custom"
            className="bg-[#1976D2] text-white whitespace-nowrap"
            to={buttonTo}
          >
            {buttonText}
          </Button>
        </div>
      </div>
      <p className="text-[1.3rem] sm:text-[1.6rem] md:text-[1.8rem] col-span-3 font-medium text-gray-500 leading-relaxed">
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;
